import { memo } from 'react';

import { PaymentByCountry } from 'app/modules/ManagementReport/PaymentReport/PaymentByCountry';
import { PaymentByTax } from 'app/modules/ManagementReport/PaymentReport/PaymentByTax';
import { Tab, Tabs } from 'react-bootstrap';

import { label, title } from '../translation';

interface Props {}

// eslint-disable-next-line react/display-name
export const PaymentReport = memo((props: Props) => {
  return (
    <>
      <div>
        <h1 className="title">{title('pagePayment')}</h1>
        <Tabs defaultActiveKey="byCountry" id="tab-tax" className="nav-fill">
          <Tab mountOnEnter={true} eventKey="byCountry" title={label('taxpayerByCountry')}>
            <PaymentByCountry />
          </Tab>

          <Tab mountOnEnter={true} eventKey="amountTaxByTax" title={label('taxAmount')}>
            <PaymentByTax />
          </Tab>
        </Tabs>
      </div>
    </>
  );
});
